import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import { serverDate } from "../../../utils/date";
import ClientQuotasTabComponent from "../../../components/ScheduleConfig/ClientQuotasTabComponent";
import Loading from "../../../components/Loading";
import useStyles from "./styles";
import { getDataStorage } from "../../../utils/filterManagementDataStore";

const ClientQuota = ({
  quotas,
  blocks,
  loadBlocks,
  loadBlocksByDateInterval,
  branches,
  filter,
  setFilter,
  loadQuota,
  plants,
  deleteQuota,
  updateQuota,
  sendContent,
  addQuota,
  subRoutes,
  subtractQuantity,
  addQuantity,
  setQuantity,
  loadPlants,
  loadProducts,
  loadLoadingTypes,
  loadAvailableQuotas,
  availablePlantQuotas,
  getClientByDocument,
  getTransporterByCNPJ,
  loading,
  clearClientQuotas,
  addNewClientQuota,
  editQuotaQuantity,
  cloneQuotasFromLastWeek,
  getOnlyDataQuotasByWeek,
  getSchedulingsClientByPeriod,
  loadClientsByNickname,
  loadClientsByDocument,
  loadTransportersByNickname,
  loadTransportersByDocument,
}) => {
  const classes = useStyles();
  const removeItem = (quotaId) => deleteQuota(quotaId);
  const addItem = (quotaData) => addQuota(quotaData);
  const updateItem = (quotaData) => updateQuota(quotaData);
  const [turnControl, setTurnControl] = useState(false);
  const [cloneQuotasLastWeekParams, setCloneQuotasLastWeekParams] = useState({});

  useEffect(() => {

    const filterBranch = filter.clientQuotasBranch || getDataStorage('client_quotas_config_checkSingleBranch')?.value

    loadPlants(filterBranch);

  }, [loadPlants, filter.clientQuotasBranch]);

  useEffect(() => {
    let branch_id = getDataStorage('client_quotas_config_checkSingleBranch')?.value
    let plant_date = getDataStorage('client_quotas_config_selectedWeek')?.ref
    let plant_id = getDataStorage('client_quotas_config_selectedPlant')?.value
    let time_block_id = getDataStorage('client_quotas_config_selectedTurn')?.value

    const branchId = filter.clientQuotasBranch || branch_id
    const plantStartDate = moment(plant_date).clone().weekday(0).format('YYYY-MM-DD');
    const plantEndDate = moment(plant_date).clone().weekday(6).format('YYYY-MM-DD');
    const plantId = filter.clientQuotasPlant || plant_id
    const timeBlockId = !!(filter.clientQuotasTurn || time_block_id) ? (filter.clientQuotasTurn || time_block_id) : null

    setCloneQuotasLastWeekParams({
      branchId,
      plantStartDate,
      plantEndDate,
      plantId,
      timeBlockId,
    })

    if (branchId && plantStartDate && plantEndDate && plantId) {
      loadQuota(plantId, plantStartDate, plantEndDate, timeBlockId);
      loadAvailableQuotas({
        idBranch: branchId,
        date: moment(plantStartDate).format('YYYY-MM-DD'),
        idPlant: plantId,
      });
    }

  }, [
    loadQuota,
    loadAvailableQuotas,
    filter.clientQuotasBranch,
    filter.clientQuotasPlant,
    filter.clientQuotasTurn,
    filter.clientQuotasDate
  ]);

  useEffect(() => {
    let branch_id = getDataStorage('client_quotas_config_checkSingleBranch')?.value
    let present_date = getDataStorage('client_quotas_config_selectedWeek')?.ref  || filter.clientQuotasDate
    if(!!filter.clientQuotasBranch || branch_id){
      loadBlocksByDateInterval({
        branchId: filter.clientQuotasBranch || branch_id,
        startDate: moment(present_date).clone().weekday(0).format('YYYY-MM-DD'),
        endDate: moment(present_date).clone().weekday(6).format('YYYY-MM-DD')
      });
    }
   },[
      loadBlocksByDateInterval,
      filter.clientQuotasBranch,
      filter.clientQuotasDate
   ]);

  useEffect(() => {
    loadProducts();
  }, [loadProducts]);

  useEffect(() => {
    loadLoadingTypes();
  }, [loadLoadingTypes]);

  return (
    <div className={classes.root}>
      {loading && <Loading />}
      <ClientQuotasTabComponent
        blocks={blocks}
        loading={loading}
        plantQuotas={availablePlantQuotas}
        subRoutes={subRoutes}
        quotas={quotas}
        plants={plants}
        addQuantity={addQuantity}
        sendContent={sendContent}
        subtractQuantity={subtractQuantity}
        setQuantity={setQuantity}
        onDeleteItem={removeItem}
        onAddItem={addItem}
        onUpdateItem={updateItem}
        getClientByDocument={getClientByDocument}
        getTransporterByCNPJ={getTransporterByCNPJ}
        branches={branches}
        filter={filter}
        setFilter={setFilter}
        turnControl={turnControl}
        setTurnControl={setTurnControl}
        clearClientQuotas={clearClientQuotas}
        addNewClientQuota={addNewClientQuota}
        editQuotaQuantity={editQuotaQuantity}
        cloneQuotasFromLastWeek={cloneQuotasFromLastWeek}
        cloneQuotasLastWeekParams={cloneQuotasLastWeekParams}
        getOnlyDataQuotasByWeek={getOnlyDataQuotasByWeek}
        getSchedulingsClientByPeriod={getSchedulingsClientByPeriod}
        loadClientsByNickname={loadClientsByNickname}
        loadClientsByDocument={loadClientsByDocument}
        loadTransportersByNickname={loadTransportersByNickname}
        loadTransportersByDocument={loadTransportersByDocument}
      />
    </div>
  );
};

const mapState = ({
  quotas: { quotas, availablePlantQuotas, loading },
  products: { products },
  loadTypes: { types },
  plants: { plants },
  timeBlocks: { blocks, loadingBlocks },
}) => {
  return  ({
    quotas,
    products: products.map((product) => ({
      ...product,
      value: product.id,
      label: product.name,
    })),
    plants: plants.map((plant) => ({
      ...plant,
      value: plant.id,
      label: plant.name + " - " + plant.bp_number,
    })),
    idPlant: plants.id,
    loadingTypes: types.map((t) => ({ ...t, value: t.id, label: t.name })),
    availablePlantQuotas,
    loading: loading,
    blocks,
    timeBlocksLoading: loadingBlocks,
  });
}

const mapDispatch = (dispatch) => ({
  loadBlocks: (payload) => dispatch.timeBlocks.loadAsync(payload),
  loadBlocksByDateInterval: (payload) => dispatch.timeBlocks.loadByDateIntervalAsync(payload),
  loadProducts: () => dispatch.products.loadAsync(),
  loadLoadingTypes: () => dispatch.loadTypes.loadAsync(),
  loadPlants: (idBranch) => dispatch.plants.loadAsync(idBranch),
  loadQuota: (idPlant, startDate, endDate, idTimeBlock) =>
    dispatch.quotas.loadAsync({ idPlant, startDate: serverDate(startDate), endDate: serverDate(endDate), idTimeBlock }),
  cloneQuotasFromLastWeek: (idPlant, startDate, endDate, plantStartDateLastWeek, plantEndDateLastWeek, idTimeBlock) =>
    dispatch.quotas.cloneQuotasFromLastWeek({
        idPlant,
        startDate: serverDate(startDate),
        endDate: serverDate(endDate),
        plantStartDateLastWeek: serverDate(plantStartDateLastWeek),
        plantEndDateLastWeek: serverDate(plantEndDateLastWeek),
        idTimeBlock
    }),
  getOnlyDataQuotasByWeek:(idPlant, startDate, endDate, idTimeBlock) =>
    dispatch.quotas.getOnlyDataQuotasByWeek({
        idPlant:idPlant,
        startDate: serverDate(startDate),
        endDate: serverDate(endDate),
        idTimeBlock:idTimeBlock
    }),
  getSchedulingsClientByPeriod: (data) => dispatch.quotas.getSchedulingsClientByPeriod(data),
  loadAvailableQuotas: (data) => dispatch.quotas.loadAvailableQuotas(data),
  addQuota: (data) => dispatch.quotas.addAsync(data),
  updateQuota: (data) => dispatch.quotas.updateAsync(data),
  deleteQuota: (id) => dispatch.quotas.deleteAsync(id),
  addQuantity: (item) => dispatch.quotas.addQuantity(item),
  subtractQuantity: (item) => dispatch.quotas.subtractQuantity(item),
  setQuantity: (payload) => dispatch.quotas.setQuantityAsync(payload),
  sendContent: (payload) => dispatch.quotas.sendContent(payload),
  getClientByDocument: dispatch.scheduling.getClientByDocumentAsync,
  getTransporterByCNPJ: dispatch.transporters.loadTransporterByCNPJ,
  clearClientQuotas: (payload) => dispatch.quotas.clearClientQuotas(payload),
  addNewClientQuota: (payload) => dispatch.quotas.addNewClientQuota(payload),
  editQuotaQuantity: (payload) => dispatch.quotas.editQuotaQuantity(payload),
  loadClientsByNickname: (payload) => dispatch.clients.loadClientsByNicknameAsync(payload),
  loadClientsByDocument: (payload) => dispatch.clients.loadClientsByDocumentAsync(payload),
  loadTransportersByNickname: (payload) => dispatch.transporters.loadTransportersByNicknameAsync(payload),
  loadTransportersByDocument: (payload) => dispatch.transporters.loadTransportersByDocumentAsync(payload),
});

ClientQuota.propTypes = {
  blocks: PropTypes.array.isRequired,
  loadBlocks: PropTypes.func.isRequired,
  loadBlocksByDateInterval: PropTypes.func.isRequired,
  quotas: PropTypes.array.isRequired,
  branches: PropTypes.array.isRequired,
  filter: PropTypes.object.isRequired,
  setFilter: PropTypes.func.isRequired,
  loadPlants: PropTypes.func.isRequired,
  addQuota: PropTypes.func.isRequired,
  updateQuota: PropTypes.func.isRequired,
  deleteQuota: PropTypes.func.isRequired,
  setQuantity: PropTypes.func.isRequired,
  subtractQuantity: PropTypes.func.isRequired,
  addQuantity: PropTypes.func.isRequired,
  sendContent: PropTypes.func.isRequired,
  subRoutes: PropTypes.array.isRequired,
  availablePlantQuotas: PropTypes.array.isRequired,
  loadAvailableQuotas: PropTypes.func.isRequired,
  getClientByDocument: PropTypes.func.isRequired,
  getTransporterByCNPJ: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  clearClientQuotas: PropTypes.func.isRequired,
  addNewClientQuota: PropTypes.func.isRequired,
  editQuotaQuantity: PropTypes.func.isRequired,
  getOnlyDataQuotasByWeek: PropTypes.func.isRequired,
  getSchedulingsClientByPeriod: PropTypes.func.isRequired,
  loadClientsByNickname: PropTypes.func.isRequired,
  loadTransportersByNickname: PropTypes.func.isRequired,
};

export default connect(mapState, mapDispatch)(ClientQuota);
